import React from 'react';
import AdminUserPicker, { getUserLabel } from './AdminUserPicker';

const AdminOverbox = () => {
  const [platform, setPlatform] = React.useState('twitch');
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [quantity, setQuantity] = React.useState(1);
  const [status, setStatus] = React.useState('');
  const [statusType, setStatusType] = React.useState(''); // 'success' | 'error' | ''
  const [loading, setLoading] = React.useState(false);

  const handleGive = async () => {
    if (!selectedUser || !selectedUser._id) {
      setStatus('Selecciona un usuario');
      setStatusType('error');
      return;
    }
    const qty = parseInt(quantity, 10);
    // Enforce 1..1000 client-side (server enforces the same bound).
    if (isNaN(qty) || qty < 1 || qty > 1000) {
      setStatus('Cantidad inválida (debe ser un entero entre 1 y 1000)');
      setStatusType('error');
      return;
    }
    const label = selectedUser.displayname || selectedUser.youtubeDisplayName || selectedUser._id;
    setLoading(true);
    setStatus('');
    setStatusType('');
    try {
      const formData = new FormData();
      formData.append('userId', selectedUser._id);
      formData.append('quantity', qty);
      const res = await fetch('/api/adminLogin?action=giveOverbox', {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data && data.success) {
        setStatus('Overbox añadido correctamente (' + qty + ') a ' + label);
        setStatusType('success');
      } else {
        setStatus('Error: ' + (data && data.error ? data.error : 'desconocido'));
        setStatusType('error');
      }
    } catch (err) {
      setStatus('Error al dar overbox');
      setStatusType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='heroes formOver'>
      <h1>Dar Overbox</h1>
      <AdminUserPicker
        platform={platform}
        onPlatformChange={(p) => { setPlatform(p); setSelectedUser(null); }}
        selectedUser={selectedUser}
        onSelectUser={setSelectedUser}
        showOverbox
      />
      {loading ? <p>Cargando...</p> : null}
      {selectedUser ? (
        <>
          <div className='formFieldRow'>
            <label className='formFieldLabel heroes'>Cantidad de Overbox</label>
            <input
              className='userSearch'
              type='number'
              min='1'
              max='1000'
              step='1'
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              onWheel={(e) => e.currentTarget.blur()}
            />
          </div>
          <div className='navTops heroes unselectable'>
            <div onClick={handleGive}>Dar Overbox a {getUserLabel(selectedUser, platform)}</div>
          </div>
        </>
      ) : null}
      {status ? (
        <p
          role={statusType === 'error' ? 'alert' : 'status'}
          style={{
            padding: '8px 12px',
            borderRadius: 4,
            fontWeight: 600,
            color: statusType === 'success' ? '#0a6b0a' : statusType === 'error' ? '#8a1a1a' : 'inherit',
            backgroundColor: statusType === 'success' ? '#d9f5d9' : statusType === 'error' ? '#fdecea' : 'transparent'
          }}
        >
          {status}
        </p>
      ) : null}
    </div>
  );
};

export default AdminOverbox;
